module.exports = __webpack_public_path__ + "img/IMG_8155_L_WoodMatted_MockedUp.a3892837.jpg";